<template>
  <div class="view">
    <!-- <div class="">
      {{stage}}
    </div> -->
    <header>
      <h1>Contact</h1>

      <div class="close-view absolute right-4 top-4">
        <router-link :to="{ name: 'Home', params: {} }" class="w-8 h-8 block group">
          <div class="absolute top-1/2 right-0 transform rotate-45 h-0.5 w-8 bg-white group-hover:bg-red-600"></div>
          <div class="absolute top-1/2 right-0 transform -rotate-45 h-0.5 w-8 bg-white group-hover:bg-red-600"></div>
        </router-link>
      </div>

    </header>

    <VueShowdown
    :markdown="md"
    tag="article"
    />

    <router-link
    :to="{
      name: 'AR'
      }"
    class="text-xl md:text-2xl text-red-600 border-2 border-red-600 uppercase px-2 py-1 mt-1 cursor-pointer pointer-events-auto hover:border-red-600 hover:text-red-600 absolute bottom-4 left-4 right-4 text-center w-auto md:w-48">
      Launch in AR
    </router-link>

  </div>
</template>

<script>
import mdFile from '@/markdown/credits.md'
// @ is an alias to /src
export default {
  name: 'Credits',
  data () {
    return {
      text: ''
    }
  },
  computed: {
    stage () {
      return this.$store.state.stage
    },
    md () {
      return mdFile
    }
  }
}
</script>

<style lang="scss" scoped>
.view {
  @apply fixed inset-0;
  z-index:40;
  z-index: 9999 !important;
}
article {
  @apply absolute top-1/2 left-1/2 transform -translate-y-1/2 -translate-x-1/2 px-4;
}
</style>
